<h1 mat-dialog-title>
    Link Location
</h1>
<div mat-dialog-content>
    <p>
        <mat-form-field>
            <mat-label>Select Location</mat-label>
            <input type="text" matInput [formControl]="locationControl" [matAutocomplete]="auto" placeholder="Search locations">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayLocation" (optionSelected)="onLocationSelected($event)">
                @for (location of filteredLocations | async; track location) {
                    <mat-option [value]="location">{{location.name}} - {{ location.description }}</mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>
    </p>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onDismiss()">Cancel</button>
    <button cdkFocusInitial mat-raised-button color="primary" [disabled]="!selectedLocation" (click)="onConfirm()">Link Location</button>
</div>